<template>
  <div class="partnerCompanyInfo">
    <div class="partnerCompanyInfoGrid">
      <div
        v-for="item in displayFields"
        :key="item.label"
        class="partnerCompanyInfoRow"
        :class="{ 'is-multiline': item.multiline }"
      >
        <span class="partnerCompanyInfoLabel">{{ item.label }}:</span>
        <span class="partnerCompanyInfoValue">{{ item.value }}</span>
      </div>
    </div>

    <!-- 保留原有富文本详情 -->
    <!-- <div
      v-if="data.details"
      class="partnerCompanyInfoRich"
      v-html="data.details"
    /> -->

    <!-- 保留原有视频 -->
    <!-- <div v-if="videoList.length" class="partnerCompanyInfoVideos">
      <div
        v-for="(item, index) in videoList"
        :key="index"
        class="partnerCompanyInfoVideoBox"
      >
        <video
          class="partnerCompanyInfoVideo"
          muted
          preload
          :ref="'partnerVideo' + index"
          controls
          @play="onPlay(index)"
          @pause="onPause(index)"
        >
          <source :src="item" type="video/mp4" />
        </video>
        <img
          v-if="showBtn[index]"
          class="partnerCompanyInfoPlayBtn"
          src="@/assets/images/play.png"
          alt="播放"
          @click="togglePlay(index)"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import { AUTH_COOPERATION_TYPE, STAFF_COUNT } from "@/common/enum";

/** 从 data 中按多个候选字段取值 */
function pick(data, keys, fallback = "-") {
  if (!data || typeof data !== "object") return fallback;
  for (const key of keys) {
    const val = data[key];
    if (val !== undefined && val !== null && val !== "") return val;
  }
  return fallback;
}

export default {
  name: "PartnerCompanyInfo",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showBtn: {},
    };
  },
  computed: {
    videoList() {
      const video = this.data && this.data.video;
      return Array.isArray(video) ? video : [];
    },
    displayFields() {
      const d = this.data || {};
      const fields = [
        {
          label: "L1授权开始日期",
          value: pick(d, ["l1AuthStartDate", "l1StartDate"]),
        },
        {
          label: "L1授权终止日期",
          value: pick(d, ["l1AuthEndDate", "l1EndDate"]),
        },
        {
          label: "L2授权开始日期",
          value: pick(d, ["l2AuthStartDate", "l2StartDate"]),
        },
        {
          label: "L2授权终止日期",
          value: pick(d, ["l2AuthEndDate", "l2EndDate"]),
        },
        {
          label: "授权合作类型",
          value: (() => {
            const val = pick(d, ["authCooperationType"], null);
            return AUTH_COOPERATION_TYPE[val] || val || "-";
          })(),
        },
        {
          label: "授权城市",
          value:
            d.authProvince || d.authCity
              ? `${d.authProvince || ""}${d.authCity || ""}`
              : pick(d, ["authCity", "authorizedCity", "authCityName"]),
        },
        {
          label: "对应LWS良仓",
          value: pick(d, ["lwsWarehouse"]),
        },
        // {
        //   label: "对应代理商",
        //   value: pick(d, ["agentName", "agent", "correspondAgent"]),
        // },
        {
          label: "企业负责人",
          value: pick(d, ["decisionMaker"]),
        },
        {
          label: "企业负责人联系方式",
          value: pick(d, ["decisionMakerPhone"]),
        },
        {
          label: "公司经营地址",
          value: pick(d, ["businessAddress"]),
          multiline: true,
        },
        {
          label: "生产的盘柜类型",
          value: pick(d, ["cabinetType"]),
        },
        {
          label: "主要行业",
          value: pick(d, ["mainIndustry"]),
          multiline: true,
        },
        {
          label: "主要客户",
          value: pick(d, ["mainCustomer"]),
          multiline: true,
        },
        {
          label: "人员数量",
          value: (() => {
            const val = pick(d, ["staffCount"], null);
            return STAFF_COUNT[val] || val || "-";
          })(),
        },
        {
          label: "友商合作情况",
          value: pick(d, ["competitorCooperation"]),
          multiline: true,
        },
        {
          label: "所在大区",
          value: pick(d, ["region"]),
        },
        {
          label: "所在地区部",
          value: pick(d, ["regionDept"]),
        },
        {
          label: "良信负责人",
          value: pick(d, ["lxPrincipal"]),
        },
        {
          label: "良信负责人手机号",
          value: pick(d, ["lxPrincipalPhone"]),
        },
      ];

      return fields;
    },
  },
  watch: {
    videoList: {
      handler(list) {
        list.forEach((_, index) => {
          this.$set(this.showBtn, index, true);
        });
      },
      immediate: true,
    },
  },
  methods: {
    getVideoEl(index) {
      const ref = this.$refs["partnerVideo" + index];
      return Array.isArray(ref) ? ref[0] : ref;
    },
    onPlay(index) {
      this.videoList.forEach((_, i) => {
        if (i === index) return;
        const video = this.getVideoEl(i);
        if (video) video.pause();
        this.$set(this.showBtn, i, true);
      });
      this.$set(this.showBtn, index, false);
    },
    onPause(index) {
      this.$set(this.showBtn, index, true);
    },
    togglePlay(index) {
      this.videoList.forEach((_, i) => {
        if (i === index) return;
        const video = this.getVideoEl(i);
        if (video) video.pause();
        this.$set(this.showBtn, i, true);
      });
      const video = this.getVideoEl(index);
      if (video) video.play();
    },
  },
};
</script>

<style lang="less" scoped>
.partnerCompanyInfo {
  padding: 32px;
  background: #fff;
  min-height: 300px;
}
.partnerCompanyInfoGrid {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 48px;
  row-gap: 24px;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
}
.partnerCompanyInfoRow {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.6;
  &.is-multiline {
    align-items: flex-start;
  }
}
.partnerCompanyInfoLabel {
  flex-shrink: 0;
  width: 128px;
  color: #64748b;
}
.partnerCompanyInfoValue {
  flex: 1;
  min-width: 0;
  color: #1e293b;
  word-break: break-all;
}
.partnerCompanyInfoRich {
  margin-top: 32px;
  font-size: 14px;
  color: #525f66;
  line-height: 1.8;
  /deep/ img {
    max-width: 100% !important;
    height: auto !important;
  }
}
.partnerCompanyInfoVideos {
  margin-top: 24px;
}
.partnerCompanyInfoVideoBox {
  position: relative;
  margin-top: 20px;
}
.partnerCompanyInfoVideo {
  width: 100%;
  height: 480px;
  background: #00161a;
  display: block;
}
.partnerCompanyInfoPlayBtn {
  position: absolute;
  width: 80px;
  height: 80px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
</style>
